var components
try {
  components = {
    clImage: function () {
      return import(
        /* webpackChunkName: "uni_modules/cl-upload/components/cl-image/cl-image" */ "@/uni_modules/cl-upload/components/cl-image/cl-image.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.listRowStyle])
  var s1 = _vm.__get_style([_vm.rowStyle])
  var l0 = _vm.__map(_vm.previewList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m0 = _vm.fileUrlType(item)
    var s2 = m0 === "image" ? _vm.__get_style([_vm.imgStyle]) : null
    var s3 = !(m0 === "image") ? _vm.__get_style([_vm.imgStyle]) : null
    var s4 =
      !(m0 === "image") && (!_vm.autoUpload || _vm.cloudType === "other")
        ? _vm.__get_style([_vm.imgStyle])
        : null
    var s5 =
      !(m0 === "image") && !(!_vm.autoUpload || _vm.cloudType === "other")
        ? _vm.__get_style([_vm.imgStyle])
        : null
    return {
      $orig: $orig,
      m0: m0,
      s2: s2,
      s3: s3,
      s4: s4,
      s5: s5,
    }
  })
  var g0 = _vm.add && _vm.FileList.length < _vm.max
  var s6 = g0 ? _vm.__get_style([_vm.rowStyle]) : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.tempVideoUrl = ""
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        s1: s1,
        l0: l0,
        g0: g0,
        s6: s6,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }